export default __webpack_public_path__ + "static/media/flag_per.ade4092f.svg";